import api from "core/api/axiosInstance";
export async function getConcessionPeajes(code, signal) {
  if (!/^\d+$/.test(String(code))) throw new Error("Código de concesión inválido.");
  const { data } = await api.get(`/api/conciliation/get-peajes/${encodeURIComponent(code)}`, {
    signal,
    timeout: 15000,
  });
  if (
    !Array.isArray(data?.data) ||
    (data.code != null && Number(data.code) !== 0) ||
    data.success === false
  )
    throw new Error("No se pudieron consultar los peajes.");
  const names = data.data.map((item) => item?.peaje);
  if (
    !names.length ||
    names.some((name) => typeof name !== "string" || !name.trim()) ||
    new Set(names).size !== names.length
  )
    throw new Error("La concesión no tiene un listado válido de peajes. Revisa su configuración.");
  return names;
}
